import type { Lang } from "@noli/core";

import { injectScope } from "./util";

export enum AI_Params_Words {
  "type-title" = "type-title",
  "model-title" = "model-title",
  "url-title" = "url-title",
  "url-placeholder" = "url-placeholder",
  "prompt-title" = "prompt-title",
  "prompt-placeholder" = "prompt-placeholder",
  "negative-prompt-title" = "negative-prompt-title",
  "negative-prompt-placeholder" = "negative-prompt-placeholder",
  "sampler-title" = "sampler-title",
  "fidelity-caption" = "fidelity-caption",
  "w-caption" = "w-caption",
  "h-caption" = "h-caption",
  "num-steps-caption" = "num-steps-caption",
  "guidance-scale-caption" = "guidance-scale-caption",
  "circular-caption" = "circular-caption",
  "seed-caption" = "seed-caption",
  "variations-title" = "variations-title",
  "strength-caption" = "strength-caption",
  "case-key-caption" = "case-key-caption",
  "case-repeat-caption" = "case-repeat-caption",
  "submit-text" = "submit-text",
  "base-settings-title" = "base-settings-title",
  "cases-settings-title" = "cases-settings-title",
  "json-case-title" = "json-case-title",
  "add-case" = "add-case",
  "add-advanced-case" = "add-advanced-case",
  "add-json-case" = "add-json-case",
  "save-config" = "save-config",
  "case-meta-settings-title" = "case-meta-settings-title",
  "delete-case" = "delete-case",
  "delete-all-cases" = "delete-all-cases",
  "load-to-cases" = "load-to-cases",
  "empty-cases-warning" = "empty-cases-warning",
  "parseParamsErrorMessage" = "parseParamsErrorMessage",
  "typeNotSupportMessage" = "typeNotSupportMessage",
  "originImageCaption" = "originImageCaption",
  "maskUrlCaption" = "maskUrlCaption",
}

injectScope("ai_params", AI_Params_Words);

export const paramsRecords: Record<Lang, Record<AI_Params_Words, string>> = {
  zh: {
    [AI_Params_Words["type-title"]]: "参数类型",
    [AI_Params_Words["model-title"]]: "模型",
    [AI_Params_Words["url-title"]]: "url",
    [AI_Params_Words["url-placeholder"]]: "请输入图片 url",
    [AI_Params_Words["prompt-title"]]: "提示词",
    [AI_Params_Words["prompt-placeholder"]]: "请输入提示词",
    [AI_Params_Words["negative-prompt-title"]]: "负面词",
    [AI_Params_Words["negative-prompt-placeholder"]]: "请输入负面词",
    [AI_Params_Words["sampler-title"]]: "采样器",
    [AI_Params_Words["fidelity-caption"]]: "相似度",
    [AI_Params_Words["w-caption"]]: "宽",
    [AI_Params_Words["h-caption"]]: "高",
    [AI_Params_Words["num-steps-caption"]]: "采样步数",
    [AI_Params_Words["guidance-scale-caption"]]: "扣题程度",
    [AI_Params_Words["circular-caption"]]: "循环纹样",
    [AI_Params_Words["seed-caption"]]: "随机种子",
    [AI_Params_Words["strength-caption"]]: "强度",
    [AI_Params_Words["variations-title"]]: "相似",
    [AI_Params_Words["case-key-caption"]]: "唯一标识",
    [AI_Params_Words["case-repeat-caption"]]: "重复次数",
    [AI_Params_Words["submit-text"]]: "生 成",
    [AI_Params_Words["base-settings-title"]]: "基础配置",
    [AI_Params_Words["cases-settings-title"]]: "用例配置",
    [AI_Params_Words["json-case-title"]]: "请输入参数",
    [AI_Params_Words["add-case"]]: "增加用例",
    [AI_Params_Words["add-advanced-case"]]: "增加高级用例",
    [AI_Params_Words["add-json-case"]]: "导入 json 用例",
    [AI_Params_Words["save-config"]]: "保存配置",
    [AI_Params_Words["case-meta-settings-title"]]: "元配置",
    [AI_Params_Words["delete-case"]]: "删除用例",
    [AI_Params_Words["delete-all-cases"]]: "删除全部用例",
    [AI_Params_Words["load-to-cases"]]: "导入为用例",
    [AI_Params_Words["empty-cases-warning"]]: "当前未设置有效用例 😣",
    [AI_Params_Words.parseParamsErrorMessage]: "参数解析失败",
    [AI_Params_Words.typeNotSupportMessage]: "$1 类型不支持调参",
    [AI_Params_Words.originImageCaption]: "底图",
    [AI_Params_Words.maskUrlCaption]: "蒙层图片",
  },
  en: {
    [AI_Params_Words["type-title"]]: "Type",
    [AI_Params_Words["model-title"]]: "Model",
    [AI_Params_Words["url-title"]]: "url",
    [AI_Params_Words["url-placeholder"]]: "Please input the image url",
    [AI_Params_Words["prompt-title"]]: "Prompt",
    [AI_Params_Words["prompt-placeholder"]]: "Please input your prompt here",
    [AI_Params_Words["negative-prompt-title"]]: "Negative Prompt",
    [AI_Params_Words["negative-prompt-placeholder"]]: "Please input your negative prompt here",
    [AI_Params_Words["sampler-title"]]: "Sampler",
    [AI_Params_Words["fidelity-caption"]]: "Fidelity",
    [AI_Params_Words["w-caption"]]: "Width",
    [AI_Params_Words["h-caption"]]: "Height",
    [AI_Params_Words["num-steps-caption"]]: "Sample Steps",
    [AI_Params_Words["guidance-scale-caption"]]: "Guidance Scale",
    [AI_Params_Words["circular-caption"]]: "Circular Texture",
    [AI_Params_Words["seed-caption"]]: "Seed",
    [AI_Params_Words["strength-caption"]]: "Strength",
    [AI_Params_Words["variations-title"]]: "Variations",
    [AI_Params_Words["case-key-caption"]]: "ID (Should be unique)",
    [AI_Params_Words["case-repeat-caption"]]: "Repeat Times",
    [AI_Params_Words["submit-text"]]: "Submit",
    [AI_Params_Words["base-settings-title"]]: "Base Settings",
    [AI_Params_Words["cases-settings-title"]]: "Cases Settings",
    [AI_Params_Words["json-case-title"]]: "Please input JSON",
    [AI_Params_Words["add-case"]]: "Add Case",
    [AI_Params_Words["add-advanced-case"]]: "Add Advanced Case",
    [AI_Params_Words["add-json-case"]]: "Add JSON Case",
    [AI_Params_Words["save-config"]]: "Save Config",
    [AI_Params_Words["case-meta-settings-title"]]: "Meta Settings",
    [AI_Params_Words["delete-case"]]: "Delete Case",
    [AI_Params_Words["delete-all-cases"]]: "Delete All Cases",
    [AI_Params_Words["load-to-cases"]]: "Load to Cases",
    [AI_Params_Words["empty-cases-warning"]]: "Cannot find valid cases 😣",
    [AI_Params_Words.parseParamsErrorMessage]: "Failed to parse params 😣",
    [AI_Params_Words.typeNotSupportMessage]: "Type $1 is not supported to arrange",
    [AI_Params_Words.originImageCaption]: "Origin Image",
    [AI_Params_Words.maskUrlCaption]: "Mask Image",
  },
};
